var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTexto = function SvgTexto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.19 24.47-8.57.15-.04-2.46 8.57-.15.04 2.46ZM19.31 12.6h.8l-5.85 17.43-2.86.05 6.83-20.12 2.86-.05 7.51 19.88-2.86.05L19.3 12.6Z"
  })));
};
export default SvgTexto;